$.fn.DepotTable = function(_depot) {
	var self = this;

	self.clicked_row = function() {
		var json_string = $(this).find('td:last-child textarea').val();
		var id = $(this).find('td:last-child input[name="id"]').val();
		var name = $(this).find('td:last-child input[name="name"]').val();
		var credit = asFloat($(this).find('td:last-child input[name="credit"]').val());
		var data = JSON.parse(json_string);
		_depot.details.display(id, name, credit, data);
	}

	return function() {
		self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[1, 'asc']],
			layout: {
				topStart: 'search',
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$('.dt-container > .row:first-child').css('visibility', 'visible');
				$(".dt-search").append($('#depot-filters').css('display', 'inline-block'));
				$(".dt-search input[type=search]").unbind().bind('keypress', function(e) {
					if (e.keyCode == 13) {
						self.DataTable().search(this.value).draw();
					}
				});
				$('.dt-search .table-search-clear').off().on('click', function() {
					if (!$(".dt-search input[type=search]").val()) {
						return;
					}
					$(".dt-search input[type=search]").val('');
					setTimeout(function() {
						self.DataTable().search('').draw();
					}, 35);
				});
				$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
				$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em').focus();
			},
			footerCallback: function(row, data, start, end, display) {
				let total = 0
				display.forEach(function(index) {
					total += data[index].total.total_amount;
				})
				$('.due-table-total').html(total.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}) + '&thinsp;$');
			},
		});
		self.on('click', 'tbody tr', self.clicked_row);
		return self;
	}();
}

$.fn.DepotList = function(_depot) {
	var self = this;
	return function() {
		self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			layout: {
				topStart: 'search',
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$('.dt-container > .row:first-child').css('visibility', 'visible');
				$(".dt-search").append($('#depot-list-filters').css('display', 'inline-block'));
				$(".dt-search input[type=search]").unbind().bind('keypress', function(e) {
					if (e.keyCode == 13) {
						self.DataTable().search(this.value).draw();
					}
				});
				$('.dt-search .table-search-clear').off().on('click', function() {
					if (!$(".dt-search input[type=search]").val()) {
						return;
					}
					$(".dt-search input[type=search]").val('');
					setTimeout(function() {
						self.DataTable().search('').draw();
					}, 35);
				});
				$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
				$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em').focus();
			}
		});
		return self;
	}();
}

$.fn.DepotDetails = function(_depot) {
	var self = this;
	self.current_id = undefined;
	self.selectToggle = false;
	self.amountChanged = false;
	self.table = undefined;
	self.el = {
		title: self.find('h5 .name-cell'),
		instruction: self.find('.hide-on-select'),
		wrapper: self.find('.table-wrapper'),
		select_all: self.find('.btn-action-select-all'),
		date_field: self.find('input[name="payment_date"]'),
		total_cell: self.find('span.invoices-total-cell'),
		code_field: self.find('input[name="payment_code"]'),
		amount_field: self.find('input[name="payment_amount"]'),
		cheque_field: self.find('input[name="payment_cheque"]'),
		payment_form: self.find('form'),
		credit: self.find('.credit-container'),
		credit_cell: self.find('.credit-cell'),
		account_report: self.find('a.rapport-a-payer'),
	};

	self.checked_row = function() {
		var checkbox = $(this).find('input[name="depot_invoice"]');
		if (checkbox.prop('checked') == true) {
			checkbox.prop('checked', false).change();
		} else {
			checkbox.prop('checked', true).change();
		}
	};

	self.display = function(id, name, credit, data) {
		if (self.current_id != id) {
			self.current_id = id;
			self.el.title.text(name);
			if (credit > 0) {
				self.el.credit_cell.html(credit.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}));
				self.el.credit.show();
			} else {
				self.el.credit_cell.html((0).toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}));
				self.el.credit.show();
			}
			self.el.instruction.remove();
			self.el.wrapper.removeClass('d-none');
			self.table.clear();
			self.table.rows.add(data).draw();
			self.changeRapportLink()
		}
	};

	self.tableChanged = function() {
		self.unselectAll();
		self.find('input[type="checkbox"]').on('change', self.selectionChanged);
	}

	self.changeRapportLink = function() {
		var link = '/depot/a-payer/' + self.current_id, request = ''
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				if (!request) {
					request = '?selection='
				} else {
					request += ',';
				}
				request += $(this).val();
			}
		});
		self.el.account_report.attr('href', link + request);
	}

	self.selectionChanged = function() {
		var allSelected = true;
		var paymentTotal = 0, creditAmount = asFloat(self.el.credit_cell.text());
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				var lineTotal = asFloat($(this).closest('tr').find('input[name="total"]').val());
				paymentTotal += lineTotal;
			} else {
				allSelected = false;
			}
		});
		var displayedTotal = paymentTotal - creditAmount;
		if (displayedTotal < 0) {
			displayedTotal = 0;
		}
		if (!self.amountChanged) {
			self.el.amount_field.val(displayedTotal.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		}
		self.el.total_cell.text(displayedTotal.toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		if (allSelected) {
			self.selectToggle = true;
			self.displayUnselectAllButton();
		} else {
			self.selectToggle = false;
			self.displaySelectAllButton();
		}
		self.changeRapportLink();
	}

	self.selectAll = function() {
		if (!self.selectToggle){
			self.selectToggle = true;
			self.find('input[type="checkbox"]').prop('checked', true).change();
			self.displayUnselectAllButton();
		} else {
			self.selectToggle = false;
			self.find('input[type="checkbox"]').prop('checked', false).change();
			self.displaySelectAllButton();
		}
	};

	self.unselectAll = function() {
		self.selectToggle = false;
		self.find('input[type="checkbox"]').prop('checked', false).change();
		self.el.date_field.val(self.el.date_field.data('today'));
		self.el.cheque_field.val('');
		self.el.code_field.val('').trigger('change');
		self.el.amount_field.val(asFloat(0).toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		self.displaySelectAllButton();
		self.amountChanged = false;
	};

	self.displaySelectAllButton = function() {
		self.el.select_all.find('span:not(.material-symbols-outlined)').text("Sélectionner tout");
		// self.el.select_all.find('i').removeClass("fa-close").addClass("fa-check");
	};

	self.displayUnselectAllButton = function() {
		self.el.select_all.find('span:not(.material-symbols-outlined)').text("Désélectionner tout");
		// self.el.select_all.find('i').removeClass("fa-check").addClass("fa-close");
	};

	self.code_changed = function() {
		if (self.el.code_field.val()) {
			if (self.request != undefined) {
				self.request.abort()
			}
			$('.code-link').remove()
			self.el.code_field.val(self.el.code_field.val().trim())
			self.request = $.ajax('/depot/code-check', {
				type: 'POST',
				data: {
					code: self.el.code_field.val(),
					contact_id: self.current_id,
				},
				dataType: 'json',
				success: function(x) {
					$('input[name="depot_invoice"]').prop('checked', false).trigger('change')
					x.forEach(function(invoice_id) {
						$('input[name="depot_invoice"][value="' + invoice_id + '"]').prop('checked', true).trigger('change')
					})
					self.el.code_field.after('<a href="/depot/code/' + self.current_id + '?code=' + self.el.code_field.val() + '" class="btn btn-sm btn-primary code-link" target="_blank">Consulter</a>')
					self.request = undefined
				}
			})
		} else {
			$('.code-link').remove()
		}
	}

	self.submit_form = function(e) {
		// gather data
		var request = new FormData(), data = {}, paidMinimum = 0;
		data.contact_id = self.current_id;
		data.invoices = [];
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				data.invoices.push($(this).val());
				paidMinimum += asFloat($(this).closest('tr').find('input[name="total"]').val())
			}
		});
		data.date = self.el.date_field.val();
		data.amount = asFloat(self.el.amount_field.val());
		data.cheque = self.el.cheque_field.val();
		data.code = self.el.code_field.val();

		// deposit specified
		if ($('input[name="deposit_id"]').val()) {
			data.deposit_id = $('input[name="deposit_id"]').val();
		}

		// validate over & under
		var availableAmount = data.amount + asFloat(self.el.credit_cell.text());
		if (availableAmount >= paidMinimum - .05) {	// 5¢ leniency in rounding totals
			if (availableAmount <= paidMinimum + .05) {	// 5¢ leniency in rounding totals
				// same amount
				request.append("model", "deposit");
				request.append("action", "make_payment");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			} else {
				// larger amount (will credit contact)
				swal({
					title: "Un crédit de " + (availableAmount - paidMinimum).toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}) + " $ sera appliqué",
					text: "Le montant disponible est supérieur au total des factures sélectionnées. Un crédit sera appliqué au dossier de " + $('#depot-details h5:first strong').html() + '.',
					type: "warning",
					showCancelButton: true,
					confirmButtonClass: "btn-success",
					confirmButtonText: "Continuer",
					cancelButtonText: "Annuler",
					closeOnConfirm: true,
					closeOnCancel: true
				}, function(isConfirm) {
					if (isConfirm) {
						// same amount
						request.append("model", "deposit");
						request.append("action", "make_payment");
						request.append("data", JSON.stringify(data));

						// add request to queue
						$.slr.db.add(request);
					}
				});
			}
		} else {
			swal({
				title: "Montant insuffisant",
				text: "Le montant est insuffisant pour les factures sélectionnées. Veuillez désélectionner une ou plusieurs factures.",
				type: "error",
				showCancelButton: true,
				confirmButtonClass: "btn-info",
				confirmButtonText: "Annuler",
				cancelButtonText: "Forcer le dépôt",
				closeOnConfirm: true,
				closeOnCancel: true,
				allowEnterKey: false,
			}, function(isConfirm) {
				if (!isConfirm) {	// to avoid "enter" default is cancel
					// same amount
					request.append("model", "deposit");
					request.append("action", "make_payment");
					request.append("data", JSON.stringify(data));

					// add request to queue
					$.slr.db.add(request);
				}
			});
		}
		return false;
	};

	self.updated = function(invoice_ids, credit) {
		self.unselectAll();

		/* remove lines */
		self.find('input[type="checkbox"]').each(function() {
			if (invoice_ids.indexOf($(this).val()) !== -1) {
				$(this).closest('tr').fadeOut(300, function() {
					self.table.row($(this)).remove().draw();
				});
			}
		});

		/* update credit */
		self.set_credit(credit)

		/* update table */
		_depot.table.DataTable().ajax.reload();
	};

	self.set_credit = function(credit) {
		/* update credit */
		var credit = asFloat(credit);
		if (credit >= 0.05) {
			self.el.credit_cell.html(credit.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			self.el.credit.show();
		} else {
			self.el.credit_cell.html((0).toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			self.el.credit.show();
		}

		/* credit in hidden field */
		$('.due-table').find('input[name="id"][value="' + self.current_id + '"]').parent().find('input[name="credit"]').val(credit)
	}

	self.delete_payment = function(e) {
		var request = new FormData(), data = {};
		data.payment_id = $(this).data('delete-payment');
		data.deposit_id = $(this).data('deposit');
		data.contact_id = $(this).data('contact');
		swal({
			title: "Suppression d'un paiement",
			text: "Ceci effacera le paiement et marquera toutes les factures associées comme étant non-payées.",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-success",
			confirmButtonText: "Oui, supprimer ce paiement",
			cancelButtonText: "Annuler",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm) {
			if (isConfirm) {
				// same amount
				request.append("model", "deposit");
				request.append("action", "withdraw_payment");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			}
		});
	};

	self.credit_clicked = function() {
		var bypass_value = prompt('Veuillez entrer le montant de la correction.');
		if (bypass_value || bypass_value === 0 || bypass_value === '0') {
			if (bypass_value < 0) {
				bypass_value = 0
			}
			bypass_value = bypass_value.replace(',', '.');
			bypass_value = bypass_value.replace(' ', '');
			bypass_value = bypass_value.replace(' ', '');
			bypass_value = parseFloat(bypass_value);
			if (!isNaN(bypass_value)) {
				if (bypass_value < 0.05) {
					bypass_value = 0;
				}

				// gather data
				var request = new FormData(),
				data = {};

				// build request
				request.append("model", "deposit");
				request.append("action", "credit");
				request.append("data", JSON.stringify({
					contact_id: self.current_id,
					credit: bypass_value,
				}));

				// add request to queue
				$.slr.db.add(request, function(x) {
					self.set_credit(bypass_value)
				});
			}
		}
	};

	return function() {
		// Initialize data table
		$("table.details-table").each(function(){
			self.table = $(this).DataTable({
				language: {
					url: '/assets/libraries/DataTables-fr_FR.json',
				},
				order: [[2, 'asc']],
				layout: {
					topStart: null,
					topEnd: null,
					bottomStart: null,
					bottomEnd: null,
				},
				paging: false,
			});
			self.table.on('draw', self.tableChanged);
		});
		$("table.deposit-table").each(function(){
			self.table = $(this).DataTable({
				language: {
					url: '/assets/libraries/DataTables-fr_FR.json',
				},
				layout: {
					topStart: null,
					topEnd: null,
					bottomStart: null,
					bottomEnd: null,
				},
				paging: false,
			});
			self.table.on('draw', self.tableChanged);
		});
		self.on('click', 'table.details-table tbody tr', self.checked_row);
		self.on('click', 'table.deposit-table button[data-delete-payment]', self.delete_payment);
		self.el.select_all.on('click', self.selectAll)
		self.find('.depot-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});
		self.el.payment_form.on('submit', self.submit_form);
		self.el.code_field.on('input', self.code_changed);
		self.el.amount_field.on('keypress change', function() {
			var currentAmount = asFloat(self.el.amount_field.val());
			if (currentAmount > 0) {
				self.amountChanged = true;
			} else {
				self.amountChanged = false;
			}
		});
		self.el.credit_cell.on('click', self.credit_clicked);
		return self;
	}()
}

$.fn.Depot = function() {
	var self = this;
	self.table = undefined;
	self.details = undefined;
	self.list = undefined;
	self.interface = {
		btn_close_deposit: $('.btn-action-close-deposit'),
	};

	self.close_deposit = function() {
		swal({
			title: "Fermeture du dépôt en cours",
			text: "Êtes-vous certain de vouloir fermer le dépôt en cours?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-success",
			confirmButtonText: "Oui, fermer le dépôt",
			cancelButtonText: "Annuler",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm) {
			if (isConfirm) {
				var request = new FormData(), data = {};
				request.append("model", "deposit");
				request.append("action", "close");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			}
		});
	}

	return function() {
		self.table = self.find('.due-table').DepotTable(self);
		self.list = self.find('.list-table').DepotList(self);
		self.details = self.find('#depot-details').DepotDetails(self);
		self.interface.btn_close_deposit.on('click', self.close_deposit);
		var at_date_picker = $('.input-group.date').not('.depot-date-picker');
		if (at_date_picker.length) {
			at_date_picker.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			}).on('dp.change', function(e) {
				if (!e.date) return;
				if (e.date.isSame(moment(), 'day')) {
					location.href = '/depot/comptes/';
				} else {
					location.href = '/depot/comptes-recevoir-date/' + e.date.format('YYYYMMDD');
				}
			});
		}
		return self;
	}()
}
